import React from 'react';
import TextField from '@mui/material/TextField';
import AuthStore from '../../Auth/AuthStore';
import MainStore from '../../../MainStore';
import WorkStore from './WorkStore';
import IconButton from '@mui/material/IconButton';
import SaveIcon from '@mui/icons-material/SaveRounded';
import AddIcon from '@mui/icons-material/Add';

export default class WorkCost extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            expanded: []
        }

        this.load = this.load.bind(this);
        this.handleChange = this.handleChange.bind(this);
        this.handleSave = this.handleSave.bind(this);
        this.handleWorkClick = this.handleWorkClick.bind(this);
    }

    componentDidMount() {
        this.load();
    }

    handleSave(callback) {
        MainStore.setMaskVisible();
        var token = localStorage.getItem("token");
        fetch('api/Work/SaveCosts', {
            method: 'POST',
            body: JSON.stringify(this.state.costs),
            headers: {
                'Content-Type': 'application/json',
                'Authorization': 'Bearer ' + token
            }
        }).then(function (res) {
            if (res.status === 401) {
                AuthStore.openLogin();
                MainStore.setMaskUnvisible();
                //scope.startSearch();
            }
            else {
                res.json().then((result) => {
                    MainStore.setMaskUnvisible();
                    if (callback) callback();

                }).catch((err) => console.log(err));
            }
        });
    }

    handleAddWork = id => evt => {
        var scope = this;
        var token = localStorage.getItem("token");
        scope.handleSave(() => {
            MainStore.setMaskVisible();
            
            fetch('api/Work/AddWorkByCost', {
                method: 'POST',
                body: JSON.stringify({ workId: this.props.workId, costId: id }),
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': 'Bearer ' + token
                }
            }).then(function (res) {
                if (res.status === 401) {
                    AuthStore.openLogin();
                    MainStore.setMaskUnvisible();
                    //scope.startSearch();
                }
                else {
                    res.json().then((result) => {

                        var costs = scope.state.costs.slice(0);
                        var index = costs.findIndex(c => c.id === id);
                        costs[index].linkedWorkId = result.id;
                        costs[index].linkedWorkNumber = result.number;
                        costs[index].linkedWorkCaption = result.caption;
                        if (scope.props.onUpdate) {
                            scope.props.onUpdate(costs);
                        }
                        scope.setState({ costs: costs });
                        MainStore.setMaskUnvisible();
                        WorkStore.openWorkDialog(result);

                    }).catch((err) => console.log(err));
                }
            });
        });
    }

    handleChange = id => evt => {
        var costs = this.state.costs.slice(0);
        var index = costs.findIndex(c => c.id === id);
        costs[index].value = parseFloat(evt.target.value);
        if (this.props.onUpdate) {
            this.props.onUpdate(costs);
        }
        this.setState({costs: costs});
    }

    load() {
        if (!this.props.workId) return;
        var scope = this;
        MainStore.setMaskVisible();
        var token = localStorage.getItem("token");
        fetch('api/Work/Costs?workId=' + this.props.workId, {
            method: 'GET',
            headers: {
                'Authorization': 'Bearer ' + token
            },
            body: null,
        }).then(function (res) {
            if (res.status === 401) {
                AuthStore.openLogin();
                MainStore.setMaskUnvisible();
            }
            else {
                res.json().then((result) => {
                    MainStore.setMaskUnvisible();
                    scope.setState({ costs: result });
                }).catch((err) => console.log(err));
            }
        });
    }

    handleWorkClick(workId) {
        MainStore.setMaskVisible();
        fetch('api/Work/GetWork?id=' + workId, {
            method: 'GET',
            body: null,
        }).then(function (res) {
            if (res.status === 401) {
            }
            else {
                res.json().then((result) => {
                    MainStore.setMaskUnvisible();
                    WorkStore.openWorkDialog(result);
                }).catch((err) => console.log(err));
            }
        });
    }

    render() {
        return (
            <div className="costs-block">
                {!this.props.workId && <div><h1>Сначала нужно сохранить задачу</h1></div>}
                {this.state.costs && this.state.costs.map(c => <div className="cost-item">

                    <TextField required
                        id="standard-fact-required"
                        label={c.name}
                        fullWidth
                        type="number"
                        margin="none"
                        value={c.value}
                        onChange={this.handleChange(c.id)}
                    />
                    {c.linkedWorkId && 
                        <div className="work-link" onClick={() => { this.handleWorkClick(c.linkedWorkId) }}>{c.linkedWorkNumber}</div>
                    }
                    {!c.linkedWorkId && <IconButton
                        aria-label="more"
                        aria-controls="long-menu"
                        aria-haspopup="true"
                        onClick={this.handleAddWork(c.id)}
                        size="large">
                        <AddIcon />
                    </IconButton>}
                </div>)}

                Итого: {this.state.costs && this.state.costs.reduce((accumulator, v) => accumulator + v.value, 0) * (1.0 + this.props.riskPercent / 100.0)}

                {this.props.isShowSave && <IconButton
                    aria-label="more"
                    aria-controls="long-menu"
                    aria-haspopup="true"
                    onClick={this.handleSave}
                    size="large">
                    <SaveIcon />
                </IconButton>}
            </div>
        );
    }
}
